<template>
  <div id="info" class="grid grid-cols-1">
    <resource-info-item label="Title" :value="resource.identification.title" :featured="true" />
    <resource-info-item label="Description" :value="stripHtmlTags(resource.identification.abstract)" :featured="false" />
    <resource-info-item label="Publisher" :value="resource.publisher.name" :featured="false" />
    <resource-info-item label="Published" :value="dateString(resource.identification.dates.publication)" :featured="false" />
    <resource-info-item label="Last Update" :value="dateString(resource.identification.dates.revision)" :featured="false" />
    <resource-info-item
      label="Source Metadata"
      :value="resource.identification.metadataUrl"
      :featured="false"
      :link="resource.identification.metadataUrl"
    />
  </div>
</template>

<script>
import { computed, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { dateString } from '@/services/common/date-helpers'
import ResourceInfoItem from '@/components/details-components/ResourceInfoItem'
import { stripHtmlTags } from '@/services/common/helpers'

export default {
  name: 'ResourceInfo',
  components: { ResourceInfoItem },
  props: {
    resource: {
      required: true,
    },
  },
  setup() {
    const store = useStore()
    return { dateString, stripHtmlTags }
  },
}
</script>

<style scoped>

</style>
